import { AsyncPipe } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, HostListener, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthState } from '@app/enum/auth-state.enum';
import { GlobalSearchOverlayComponent } from '@components/global-search/global-search-overlay/global-search-overlay.component';
import { AnalyticsService } from '@services/analytics/analytics.service';
import { SearchUiService } from '@services/search/search-ui.service';
import { ServiceWorkerService } from '@services/service-worker/service-worker.service';

import { FooterComponent } from './components/footer/footer.component';
import { DesktopHeaderComponent } from './components/header/desktop-header/desktop-header.component';
import { MobileHeaderComponent } from './components/header/mobile-header/mobile-header.component';
import { PwaPopupComponent } from './components/pwa-popup/pwa-popup.component';
import { AuthService } from './services/auth/auth.service';
import { PreconnectService } from './services/preconnect/preconnect.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    AsyncPipe,
    DesktopHeaderComponent,
    FooterComponent,
    GlobalSearchOverlayComponent,
    MobileHeaderComponent,
    PwaPopupComponent,
    RouterOutlet
  ],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class AppComponent implements AfterViewInit {
  private readonly analyticsService: AnalyticsService = inject(AnalyticsService);
  private readonly preconnectService: PreconnectService = inject(PreconnectService);
  private readonly searchUiService: SearchUiService = inject(SearchUiService);
  private readonly serviceWorkerService: ServiceWorkerService = inject(ServiceWorkerService);
  public readonly authService: AuthService = inject(AuthService);
  public readonly authState = AuthState;

  @HostListener('document:keydown', ['$event'])
  public onGlobalKeydown(event: KeyboardEvent): void {
    if (!(event.metaKey || event.ctrlKey) || event.key.toLowerCase() !== 'k') {
      return;
    }

    const target = event.target as HTMLElement | null;
    const tagName = target?.tagName?.toLowerCase();
    if (tagName === 'input' || tagName === 'textarea' || target?.isContentEditable) {
      return;
    }

    event.preventDefault();
    this.analyticsService.trackEvent('global_search', 'open', 'keyboard_shortcut');
    this.searchUiService.open();
  }

  public ngAfterViewInit(): void {
    // ios  :hover and :active pseudo classes bug fix
    document.addEventListener(
      'touchstart',
      () => {
        return;
      },
      false
    );
  }
}
